import tasksService, { Task } from '../../services/api/tasksService';

export const loadAllProjectTasks = async (projectId: string): Promise<Task[]> => {
  const rows: Task[] = [];
  let page = 1;
  let totalPages = 1;
  do {
    const response = await tasksService.getTasks({ projectId, page, limit: 100 });
    rows.push(...response.tasks);
    totalPages = response.totalPages;
    page += 1;
  } while (page <= totalPages);
  return rows;
};
